import React,{ useEffect, useRef } from 'react'
import { DocumentEditorContainerComponent, Toolbar } from '@syncfusion/ej2-react-documenteditor';
DocumentEditorContainerComponent.Inject(Toolbar);

function EditDriveFile() {

  const documentEditorRef = useRef(null);

  const handleSave = () => {
    if (documentEditorRef.current) {
      // Save the document in DOCX format
      documentEditorRef.current.documentEditor.save('MyDocument', 'Docx');
    }
  };

  const documentUrl = 'https://fcplfmsbucket.s3.ap-south-1.amazonaws.com/DEPLOY_NODE_JS_APP_ON_AWS.docx';

  const loadDocument = async () => {
    try {
      const response = await fetch(documentUrl);
      if (!response.ok) {
        throw new Error('Failed to load the document');
      }
      const blob = await response.blob();
      if (!blob || blob.size === 0) {
        throw new Error('The document is empty or corrupted');
      }
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        if (documentEditorRef.current && documentEditorRef.current.documentEditor) {
          const arrayBuffer = e.target.result;
          documentEditorRef.current.documentEditor.open(arrayBuffer);
        }
      };
      fileReader.readAsArrayBuffer(blob);
    } catch (error) {
      console.error('Error loading document:', error);
    }
  };

  useEffect(() => {
    loadDocument();
  
    if (documentEditorRef.current && documentEditorRef.current.documentEditor) {
      documentEditorRef.current.documentEditor.documentChange = () => {
        console.log('Document loaded successfully');
      };
    }
  }, []);

  return (
    <div>
    <button onClick={handleSave}>Save as DOCX</button>
    <DocumentEditorContainerComponent
      height='600px' // Set a specific height value
      ref={documentEditorRef}
      id="container"
      enableToolbar={true}
      toolbarItems={[
        'Undo', 'Redo', 'Image', 'Table', 'Header', 'Footer', 'PageSetup', 'PageNumber',
        'Break', 'Find', 'LocalClipboard', 'RestrictEditing', 'TrackChanges', 
        'FormFields',
      ]}
    />
      </div>
  )
}

export default EditDriveFile